import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    // obtain UTM data to send to AC
    this.route.queryParams.subscribe(params => {
      if (params.utm_source) {
        localStorage.setItem('utm_source', params.utm_source);
      }
      if (params.utm_campaign) {
        localStorage.setItem('utm_campaign', params.utm_campaign);
      }
      if (params.utm_medium) {
        localStorage.setItem('utm_medium', params.utm_medium);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts